module.exports = __webpack_public_path__ + "img/jinniao_icon05.3219a3b1.png";